export default __webpack_public_path__ + "static/media/partner-7.33b89037.jpg";